<template>
  <button>
    <i class="fas fa-arrow-left tw:text-gray-500" style="font-size: 24px" @click="handleBack" />
  </button>
</template>
<script setup lang="ts">
import { useBrand } from '@/composables/useBrand';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const { isSicuraSolution } = useBrand();

function handleBack() {
  if (route.query.forceBack) {
    window.open(route.query.forceBack.toString(), '_self');
  }
  else {
    const name = isSicuraSolution.value ? 'SicuraSolutionLauncher' : 'Launcher';
    router.push({ name });
  }
}
</script>
